import React, { useState } from 'react'
import Image from 'next/image'
import ButtonWithArrow from '../../home-page/home-page-widgets/ButtonWithArrow'

const DesignDetailsForm = () => {
  const [design, setDesign] = useState('')
  const [metalOption, setMetalOPtions] = useState('')
  const [focusedField, setFocusedField] = useState('')
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    priceRange: '',
    designNotes: '',
  })

  const handleChange = (e: any) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleFormSubmit = (e: any) => {
    e.preventDefault()
    console.log('Form data:', formData)
  }

  type FormLebelProp = {
    children: React.ReactNode
  }

  return (
    <>
      <form className=' space-y-6' onSubmit={handleFormSubmit}>
        <div className='md:w-full flex gap-5'>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic ${
                focusedField === 'firstName' || formData.firstName
                  ? 'top-[-20px] text-sm'
                  : 'top-2 text-[20px]'
              }`}
            >
              First Name*
            </label>
            <input
              type='text'
              name='firstName'
              value={formData.firstName}
              placeholder=''
              className='bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4'
              onFocus={() => setFocusedField('firstName')}
              onBlur={() => setFocusedField('')}
              onChange={handleChange}
            />
          </div>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic ${
                focusedField === 'lastName' || formData.lastName
                  ? 'top-[-20px] text-sm'
                  : 'top-2 text-[20px]'
              }`}
            >
              Last Name*
            </label>
            <input
              type='text'
              name='lastName'
              value={formData.lastName}
              placeholder=''
              className='bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4'
              onFocus={() => setFocusedField('lastName')}
              onBlur={() => setFocusedField('')}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className=' md:w-full grid md:flex gap-5 sm:mt-[0px] mt-[1.25rem]'>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic ${
                focusedField === 'email' || formData.email
                  ? 'top-[-20px] text-sm'
                  : 'top-2 text-[20px]'
              }`}
            >
              Email*
            </label>
            <input
              type='text'
              name='email'
              value={formData.email}
              placeholder=''
              className='bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4'
              onFocus={() => setFocusedField('email')}
              onBlur={() => setFocusedField('')}
              onChange={handleChange}
            />
          </div>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic ${
                focusedField === 'phone' || formData.phone
                  ? 'top-[-20px] text-sm'
                  : 'top-2 text-[20px]'
              }`}
            >
              Phone*
            </label>
            <input
              type='text'
              name='phone'
              value={formData.phone}
              placeholder=''
              className='bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4'
              onFocus={() => setFocusedField('phone')}
              onBlur={() => setFocusedField('')}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className=' md:w-full grid md:flex gap-5 sm:mt-[0px] mt-[1.25rem]'>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic ${
                focusedField === 'design' || design
                  ? 'top-[-20px] text-sm'
                  : 'top-2 text-[20px]'
              }`}
            >
              Design Options*
            </label>
            <select
              className='font-cambonMediumItalic placeholder-white bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4 appearance-none'
              value={design}
              onFocus={() => setFocusedField('design')}
              onBlur={() => setFocusedField('')}
              onChange={(e) => setDesign(e.target.value)}
            >
              <option value='' disabled hidden></option>
              <option className='!text-black' value='Rings'>
                Rings
              </option>
              <option className='!text-black' value='Necklace'>
                Necklace
              </option>
              <option className='!text-black' value='Bracelet'>
                Bracelet
              </option>
              <option className='!text-black' value='Pendant'>
                Pendant
              </option>
            </select>
          </div>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic ${
                focusedField === 'metalOption' || metalOption
                  ? 'top-[-20px] text-sm'
                  : 'top-2 text-[20px]'
              }`}
            >
              Metal Options*
            </label>
            <select
              className='font-cambonMediumItalic placeholder-white bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4 appearance-none'
              value={metalOption}
              onFocus={() => setFocusedField('metalOption')}
              onBlur={() => setFocusedField('')}
              onChange={(e) => setMetalOPtions(e.target.value)}
            >
              <option value='' disabled hidden></option>
              <option className='!text-black' value='18K Yellow Gold'>
                18K Yellow Gold
              </option>
              <option className='!text-black' value='18K White Gold'>
                18K White Gold
              </option>
              <option className='!text-black' value='18K Rose Gold'>
                18K Rose Gold
              </option>
            </select>
          </div>
        </div>
        <div className=' md:w-full hidden md:flex gap-5 '>
          <div className='relative w-1/2'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic top-2 text-[20px] ${
                focusedField === 'priceRange' ? 'top-[-20px] text-sm' : ''
              }`}
            >
              Preferred Price Range*
            </label>
            <input
              type='text'
              name='priceRange'
              placeholder=''
              className='bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4'
              onFocus={() => setFocusedField('priceRange')}
              onBlur={() => setFocusedField('')}
            />
          </div>
        </div>
        <div className=' md:w-full hidden md:flex gap-5 '>
          <div className='relative w-full'>
            <label
              className={`absolute left-0 transition-all duration-500 ease-in-out text-white font-cambonMediumItalic top-2 text-[20px] ${
                focusedField === 'designNotes' ? 'top-[-20px] text-sm' : ''
              }`}
            >
              Design notes/Date needed by*
            </label>
            <input
              type='text'
              name='designNotes'
              placeholder=''
              className='bg-transparent border-b focus:outline-none w-full text-body switch:text-[16px] lg:text-[20px] text-white sm:pt-2 pt-4'
              onFocus={() => setFocusedField('designNotes')}
              onBlur={() => setFocusedField('')}
            />
          </div>
        </div>
        <div className='flex flex-col items-start space-y-2 sm:mt-[0px] mt-[1.25rem]'>
          <label className=' text-body switch:text-[16px] lg:text-[20px] font-cambonMediumItalic text-white'>
            Upload Image*
          </label>
          <div className='w-full p-4 bg-[#01261B] h-[137px] rounded-lg flex justify-center items-center cursor-pointer relative'>
            <input
              type='file'
              className='absolute inset-0 opacity-0 cursor-pointer w-full'
            />
            <div className='text-gray-300 flex flex-col items-center'>
              <Image
                width={10}
                height={10}
                alt='Upload Icon'
                src={'/ic_upload.svg'}
                className=' h-10 w-10'
              />
            </div>
          </div>
        </div>
        <div className=' flex justify-center mx-auto'>
          <ButtonWithArrow title="Let's Get Started !" minSize={24} />
        </div>
      </form>
    </>
  )
}

export default DesignDetailsForm
